import { render, staticRenderFns } from "./GameEventStatus.vue?vue&type=template&id=3b929eb3&scoped=true"
import script from "./GameEventStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameEventStatus.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GameEventStatus.vue?vue&type=style&index=0&id=3b929eb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b929eb3",
  null
  
)

export default component.exports